import React, { useState } from 'react';
import Topbar from '../../containers/Topbar/Topbar';
import Sidebar from '../../containers/Sidebar/Sidebar';

export default function Container({ children }) {
  const [open, toggleSidebar] = useState(false);

  return (
    <>
      <Topbar
        toggleSidebar={() => {
          toggleSidebar(!open);
        }}
      />
      <Sidebar
        toggleSidebar={() => {
          toggleSidebar(!open);
        }}
        open={open}
      />

      <div
        className={
          open
            ? 'justify-center bg-black bg-opacity-20 items-center flex overflow-hidden fixed inset-0 z-[48] outline-none focus:outline-none'
            : ''
        }
        onClick={() => toggleSidebar(false)}
      ></div>
      <div
        className={`sm:ml-64 pb-8 px-4 pt-24 z-20 sm:px-10 bg-lightGray h-[calc(var(--vh,1vh)*100)] overflow-y-auto overflow-x-hidden`}
      >
        {children}
      </div>
    </>
  );
}
